import { GetNewsApi } from "@/features/news/services/get-news-api";

/// お知らせ一覧取得処理
export class GetNewsService {
  private getNewsApi = new GetNewsApi();

  /**
   * お知らせ一覧取得API実行
   */
  public async getNews() {
    return await this.getNewsApi.getNews();
  }
}
